export * from "./SplashCard"
export * from "./SplashCard.mockProps"
